/**
 * ISessionStore implementation for the browser.
 *
 * The session token lives in an httpOnly cookie set by the Gateway (see
 * FRONTEND_REFERENCE.md section 2). httpOnly cookies are invisible to
 * JavaScript by design and are attached to requests automatically by the
 * browser when fetch is called with `credentials: "include"`, so there is no
 * token value for this class to read, write, or hold in memory.
 *
 * That makes getToken/setToken/clearToken effectively no-ops here: this
 * class is not where session tokens are actually managed on the browser
 * platform, the Gateway and the browser's own cookie jar are. What this
 * class DOES provide is the single point of contact the rest of apps/web
 * talks to, instead of reaching into document.cookie or hardcoding
 * `credentials: "include"` in scattered fetch calls, so that a future
 * TauriSecureStorageSession (see PROJECT_REFERENCE.md section 16) can
 * replace it without touching any other code in the SPA.
 */
export class BrowserCookieSession {
    /**
     * Always resolves to null: an httpOnly cookie cannot be read from
     * JavaScript. Callers should not use this to check whether a session is
     * active, use the API (GET /api/v1/auth/me) for that instead.
     */
    async getToken() {
        return null;
    }
    /**
     * No-op: the session cookie is set by the Gateway via a Set-Cookie header
     * on login, never by client-side code.
     */
    async setToken(_token) {
        return;
    }
    /**
     * No-op: the session cookie can only be cleared by the Gateway (a logout
     * response with a Set-Cookie header clearing it), never by client-side
     * code, since it is httpOnly.
     */
    async clearToken() {
        return;
    }
}
//# sourceMappingURL=BrowserCookieSession.js.map